/**
 * assets/reviews.js
 * Gedrag van sections/reviews.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

(function(){
  var dataEl = document.getElementById('fp-wkk-data');
  var reviews = [];
  try { reviews = JSON.parse(dataEl.textContent || '[]'); } catch(e) { reviews = []; }
  var grid = document.getElementById('fp-reviews-grid');
  if (!grid || reviews.length === 0) return;

  var colors = ['#2A9D8F','#0B1E36','#E8530E','#6366F1','#8B5CF6','#14B8A6'];

  function bgc(name) {
    var h = 0;
    for (var i = 0; i < (name||'').length; i++) h = ((h << 5) - h) + name.charCodeAt(i);
    return colors[Math.abs(h) % colors.length];
  }

  function shortName(s) {
    if (!s || s === 'Anoniem') return 'Anoniem';
    var parts = s.trim().split(/\s+/);
    if (parts.length < 2) return parts[0];
    return parts[0] + ' ' + parts[parts.length - 1].charAt(0) + '.';
  }

  function esc(s) { return (s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

  function stars(n) {
    var h = '';
    for (var i = 1; i <= 5; i++) h += '<svg width="18" height="18" viewBox="0 0 24 24" fill="'+(i<=n?'#EA580C':'#E2E8F0')+'" stroke="none"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
    return h;
  }

  function fmtDate(d) {
    if (!d) return '';
    var p = d.split('-');
    if (p.length < 3) return d;
    var ms = ['jan','feb','mrt','apr','mei','jun','jul','aug','sep','okt','nov','dec'];
    return parseInt(p[2],10) + ' ' + ms[parseInt(p[1],10)-1] + ' ' + p[0];
  }

  /* Neem max 6 reviews met tekst, sorteer op datum */
  var shown = reviews
    .filter(function(r) { return (r.text || '').trim().length > 5; })
    .slice(0, 6);

  shown.forEach(function(r, idx) {
    var name = shortName(r.name || 'Anoniem');
    var rating = r.stars || r.rating || 5;
    var text = esc(r.text || '');
    if (text.length > 160) text = text.substring(0, 157) + '...';

    var html = '<div class="bg-white rounded-3xl p-6 md:p-8 shadow-soft flex flex-col opacity-0 translate-y-4 transition-all duration-500">'
      + '<div class="flex gap-0.5 mb-4" aria-label="' + rating + ' van 5 sterren">' + stars(rating) + '</div>'
      + '<p class="text-slate-600 text-[0.95rem] leading-relaxed m-0 mb-4 flex-1">' + text + '</p>'
      + '<div class="flex items-center gap-3 mt-auto pt-4 border-t border-slate-100">'
      + '<div class="w-10 h-10 rounded-full text-white flex items-center justify-center font-bold text-sm shrink-0" style="background:' + bgc(name) + '">' + name.charAt(0).toUpperCase() + '</div>'
      + '<div>'
      + '<strong class="text-navy text-sm block">' + esc(name) + '</strong>'
      + '<span class="text-xs text-slate-500">' + fmtDate(r.date || '') + '</span>'
      + '<span class="inline-flex items-center gap-1 text-xs text-emerald-700 mt-0.5"><svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>WebwinkelKeur geverifieerd</span>'
      + '</div></div></div>';

    grid.insertAdjacentHTML('beforeend', html);

    /* Animate in met stagger */
    setTimeout(function() {
      var cards = grid.querySelectorAll('.bg-white');
      if (cards[idx]) cards[idx].classList.remove('opacity-0', 'translate-y-4');
    }, idx * 120);
  });
})();
